"use client";

import { SortIcon } from "@/components/appIcons";
import { FilterSelect, type FilterOption } from "@/components/ui/filter-select";
import type { FacetFiltersController } from "@/facets/use-facet-filters";

/** Full-width sort select shown only below the `sm` breakpoint. */
export function FacetMobileSort({
  controller,
  options,
  placeholder,
}: {
  controller: FacetFiltersController;
  options: FilterOption[];
  placeholder: string;
}) {
  if (options.length === 0) return null;

  return (
    <FilterSelect
      icon={SortIcon}
      placeholder={placeholder}
      value={controller.sort}
      onChange={(value) => {
        if (value) controller.setSort(value);
      }}
      options={options}
      clearable={false}
      className="sm:hidden"
      intent="sort"
      triggerClassName="w-full"
      triggerLabelClassName="max-w-none"
    />
  );
}
